import { post } from '../axios'

// 新增公告
export function announcement_center_create_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/create`,
    map,
    option
  ).then(response => response)
}

// 修改公告
export function announcement_center_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/update`,
    map,
    option
  ).then(response => response)
}

// 获取公告列表
export function announcement_center_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/page`,
    map,
    option
  ).then(response => response)
}

// 获取公告明细列表
export function announcement_center_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/detail`,
    map,
    option
  ).then(response => response)
}

// 导出阅读记录
export function announcement_center_export_read_record_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/export-read-record`,
    map,
    option
  ).then(response => response)
}

// 阅读记录
export function announcement_center_read_record_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/read-record`,
    map,
    option
  ).then(response => response)
}

// 更新已读
export function announcement_center_update_read_status_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/update-read-status`,
    map,
    option
  ).then(response => response)
}

// 修改公告状态
export function announcement_center_update_status_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/update-status`,
    map,
    option
  ).then(response => response)
}

// 获取公告详情
export function announcement_center_read_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/read-detail`,
    map,
    option
  ).then(response => response)
}
